import styled from 'styled-components';

import Avatar from '@/components/Avatar/Avatar';
import { Divider, Flex, VFlex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import RoleDropdown from '@/features/Contact/RoleDropdown';
import useColor from '@/hooks/domain/useColor';
import { usePopup } from '@/stores/pure/PopupStore';
import { memberRoleDic } from '@/stores/WorkspaceStore';

type Props = MemberT & {
  isAdmin: boolean;
  changeMemberRole: (user_id: string, role: MEMBER_ROLE) => void;
  kickMember: (user_id: string) => void;
};

const MemberItem = (props: Props) => {
  const color = useColor();
  const setPopup = usePopup();
  return (
    <VFlex>
      <MemberInfoWrapper j="space-between" a="center">
        <Flex a="center" d="row" g="11px">
          <Avatar
            character={props.first_name?.[0] || '?'}
            size={32}
            color={color.profile[props.color]}
            fontSize="14px"
          />
          <VFlex>
            <Typo type="body3" color={color.gray800}>
              {props.first_name} {props.last_name}
            </Typo>
            <Typo type="body3" color={color.gray800}>
              {props.email}
            </Typo>
          </VFlex>
        </Flex>
        {props.isAdmin && !props.admin ? (
          <Flex style={{ width: 400 }}>
            <RoleDropdown
              selected={String(props.role)}
              onRemoveClick={() =>
                setPopup({
                  popupTheme: 'negative',
                  type: 'confirm',
                  title: 'Remove member',
                  message:
                    'Are you sure you want to remove this member from the workspace?',
                  onConfirm: () => {
                    props.kickMember(props.user_id);
                  },
                })
              }
              onSelect={(key) => {
                props.changeMemberRole(
                  props.user_id,
                  Number(key) as MEMBER_ROLE,
                );
              }}
            />
          </Flex>
        ) : (
          <Typo
            type="body3"
            weight="r"
            color={color.gray800}
            style={{
              width: 400,
              padding: '0px 11px',
            }}
          >
            {props.admin ? 'Admin' : memberRoleDic[props.role]}
          </Typo>
        )}
      </MemberInfoWrapper>
      <Divider direction="h" backgroundColor={color.gray400} />
    </VFlex>
  );
};

const MemberInfoWrapper = styled(Flex)`
  padding: 17px 0px;
`;

export default MemberItem;
